import { AssignmentQuiz, DashboardStream, SubjectNotice } from 'components/common/dashboard';
import { SubjectNoticePopup } from 'components/popup';
import BreadCrumb from 'components/shared/BreadCrumb';
import { DashBoardNews } from 'components/shared/dashboard/DashBoardNews';
import { useGetCalendarApi, useGetCommonApi } from 'hooks';
import { useGetRequiredApi } from 'hooks/useGetRequiredApi';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useRecoilState } from 'recoil';
import { subjectNoticePopupState } from 'recoil/dashboard/subjectNoticePopupState';
import { LeadingSubject } from './studysubject';
import { Link } from 'react-router-dom';
import { Form, Tab, Tabs } from 'react-bootstrap';
import useSsoRouting from 'hooks/common/useSsoRouting';
import { getLectureQuery } from 'api/getLectureQuery';
import { useCalendarIndex } from 'recoil/caleandar/calendarIndex';
import { CardHeader } from 'components/common';
import { ScheduleCalendar } from 'components/calendar';
import { subjectOptionDataState } from 'recoil/subject/subjectOptionDataState';

export function Main() {
  const navigate = useNavigate();
  const [subjectPopupState, setSubjectPopupState] = useRecoilState(subjectNoticePopupState);
  const [key, setKey] = useState("subjectNotice");
  const [calendarIndex, setCalendarIndex] = useRecoilState(useCalendarIndex);
  const [subjectState, setSubjectState] = useRecoilState(subjectOptionDataState);
  const [selectedTermId, setSelectedTermId] = useState(''); // 선택된 학기 ID

  const [activeKey, setActiveKey] = useState('academicSchedule'); // 기본 활성 탭 설정

  const handleTabSelect = (k) => {
    setActiveKey(k); // 탭 변경 시 상태 업데이트
  };

  const {
    // 학기정보
    semesterData,
    semesterIsLoading,
    semesterIsError,
    semestersData,
    semestersIsLoading,
    semestersIsError,
  } = useGetCommonApi();

  // 학기 데이터 로드 시 첫 번째 학기를 기본값으로 설정
  useEffect(() => {
    if (semestersData?.data?.length > 0 && !selectedTermId) {
      setSelectedTermId(semestersData.data[0].id);
    }
  }, [semestersData]);

  const {
    // 학사일정
    calendarAcademicData,
    calendarAcademicIsLoading,
    calendarAcademicIsError,
    // 유저일정
    calendarUserData,
    calendarUserIsLoading,
    calendarUserIsError,
  } = useGetCalendarApi();

  // 선택된 학기 정보
  const selectedTerm = semestersData?.data?.find((s) => String(s.id) === String(selectedTermId));
  const sisTermId = selectedTerm?.sis_term_id || '';
  const openYy = sisTermId.length >= 4 ? parseInt(sisTermId.substring(0, 4)) : null;
  const openTmGbn = sisTermId.length > 4 ? parseInt(sisTermId.substring(4)) : null;

  const {
    //   온라인 학습현황 과목선택 셀렉트박스 쿼리 (학기별)
    studentTermSelectBoxQueryData,
    studentTermSelectBoxQueryIsLoading,
    studentTermSelectBoxQueryIsError,
  } = useGetRequiredApi(null, openYy, openTmGbn);

  useEffect(() => {
    return () => {
      setSubjectPopupState({ visible: false, data: null });
    };
  }, []);

  const { ssoRouting } = useSsoRouting();
  // 온라인 강의실
  const handleGoingLecture = async (url) => {
    ssoRouting(url);
    const { data: getCanvasUrl } = await getLectureQuery('');
    
    if (getCanvasUrl?.errorCode) return;
    window.location.replace(getCanvasUrl);
  };

  const handleAttendancesAndGrades = (type, course) => {
    setSubjectState({
      courseId: course.course_id,
      courseName: course.course_name,
      termId: selectedTerm?.id,
      termName: selectedTerm?.name,
      openYy,
      openTmGbn,
    });
    if (type === 'attendance') {
      navigate('/attendance')
    } else if (type === 'grade') {
      navigate('/grade')
    }
  };

  const handleSelect = (k) => {
    setKey(k);
  };

  const switchCalendar = () => {
    setCalendarIndex(!calendarIndex);
  };

  return (
    <>
      <main id='main' className='main'>
      <div className='d-flex justify-content-start align-items-center'>
          <BreadCrumb home={'/'} sublink={'/'} title={'My Class'} subTitle={'홈'} />
          <Form.Select
            aria-label="Default select example"
            id="subjectWeek"
            name="subjectWeek"
            style={{ width: "180px", marginLeft: "20px", marginBottom: "9px" }}
            value={selectedTermId}
            onChange={(e) => setSelectedTermId(e.target.value)}
          >
            {semestersData?.data.map((semester) => (
              <option key={semester.id} value={semester.id}>
                {semester.name}
              </option>
            ))}
          </Form.Select>
        </div>
        <section className='section dashboard'>
          <div className='row'>
            <div className='col-lg-8'>
              <div className='row'>
                <div className="cards-container">
                  {studentTermSelectBoxQueryData?.map((course, idx) => (
                    <div key={course.course_id} className="horizontal-course-card">
                      <div className={`card-header ch-bg${idx + 1}`}>
                        <h3 className="card-title">{course.course_name}</h3>
                      </div>
                      <div className="card-tab">
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.course_id}`)}>
                          <img
                            src="/assets/img/icon/home_icon.png"
                            alt="Announcements Icon"
                            className="card-icon-img"
                          />
                          <div>홈</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.course_id}/announcements`)}>
                          <img
                            src="/assets/img/icon/announcements_icon.png"
                            alt="Announcements Icon"
                            className="card-icon-img"
                          />
                          <div>공지사항</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.course_id}/assignments`)}>
                          <img
                            src="/assets/img/icon/assignments_icon.png"
                            alt="Assignments Icon"
                            className="card-icon-img"
                          />
                          <div>과제</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleAttendancesAndGrades("attendance", course)}>
                          <img
                            src="/assets/img/icon/attendances_icon.png"
                            alt="Grades Icon"
                            className="card-icon-img"
                          />
                          <div>출석</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleAttendancesAndGrades("grade", course)}>
                          <img
                            src="/assets/img/icon/grades_icon.png"
                            alt="Grades Icon"
                            className="card-icon-img"
                          />
                          <div>성적</div>
                        </div>
                        <div className="card-tab-content mr-5"onClick={() => handleGoingLecture(`/courses/${course.course_id}/users`)}>
                          <img
                            src="/assets/img/icon/user_group_icon.png"
                            alt="Announcements Icon"
                            className="card-icon-img"
                          />
                          <div>사용자 및 그룹</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.course_id}/files`)}>
                          <img
                            src="/assets/img/icon/files_icon.png"
                            alt="Files Icon"
                            className="card-icon-img"
                          />
                          <div>파일</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.course_id}/assignments/syllabus`)}>
                          <img
                            src="/assets/img/icon/lecture_plan_icon.png"
                            alt="Announcements Icon"
                            className="card-icon-img"
                          />
                          <div>강의계획서</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {/* 과목 공지사항 */}
                {/* <SubjectNotice
                  data={studentSelectBoxQueryData}
                  cardTitle={semesterData?.data.name}
                  isLoading={studentSelectBoxQueryIsLoading}
                /> */}
              </div>
            </div>

            <div className='col-lg-4'>
              <div className="card p-20">
                <Tabs
                  id="schedule-tabs"
                  activeKey={activeKey}
                  onSelect={handleTabSelect}
                  className="custom-tabs"
                >
                  {/* 학사일정 탭 */}
                  <Tab eventKey="academicSchedule" title="개인일정">
                    <ScheduleCalendar
                      data={
                        calendarIndex && calendarAcademicData
                          ? calendarAcademicData
                          : []
                      }
                    />
                  </Tab>
                  {/* 개인일정 탭 */}
                  <Tab eventKey="personalSchedule" title="학사일정">
                    <ScheduleCalendar
                      data={
                        !calendarIndex && calendarUserData
                          ? calendarUserData
                          : []
                      }
                    />
                  </Tab>
                </Tabs>
              </div>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={handleSelect}
                className="custom-tabs"
              >
                <Tab eventKey="subjectNotice" title="과목 공지사항">
                  <SubjectNotice
                    data={studentTermSelectBoxQueryData}
                    cardTitle={semesterData?.data.name}
                    isLoading={studentTermSelectBoxQueryIsLoading}
                  />
                </Tab>
                <Tab eventKey="ctlNotice" title="공지사항">
                  <DashBoardNews />
                </Tab>
              </Tabs>
            </div>
          </div>
        </section>
      </main>
      {subjectPopupState.visible && <SubjectNoticePopup />}
    </>
  );
}
